import { getLogger } from "@utils/ermineLoggerUtils";
import { useQuery } from "@tanstack/react-query";
import { sendGetUserCommand } from "@utils/ermineSsrClientUtil";
import { getFormattedSdkErrorMessage } from "@utils/errorUtils";

export const useAuthCheck = () => {
    const result = useQuery({
        queryKey: ["getUser"],
        retry: false,
        queryFn: async () => {
            try {
                return await sendGetUserCommand();
            } catch (err) {
                // If the user hasn't signed in yet or has already signed out, the API will throw an exception.
                void getLogger().info(
                    err
                        ? getFormattedSdkErrorMessage(err, "SSOAuthChecker")
                        : "Failed to get user data"
                );
                throw err;
            }
        },
    });

    return {
        userInfo: result.data,
        authCheckResponseId: `get_user_${result.dataUpdatedAt}`,
        isCheckingAuth: result.isLoading,
        isAuthCheckError: result.isError,
        checkAuth: result.refetch,
    };
};
